import React from 'react';
import Experience from '../components/Experience';

const ExperiencePage: React.FC = () => {
  return (
    <Experience />
  );
};

export default ExperiencePage;
